module.exports = __webpack_public_path__ + "media/img/payments/sites-969f294e41cde7a267def84a300fbdbf.svg";